import { Record } from 'immutable';
export const ImportWarningRecord = Record({
  count: undefined,
  alteredArticlesListLink: undefined,
  isRequesting: false,
  error: undefined,
  lastLoaded: null
});
export default ImportWarningRecord;